import { Component, OnInit, Output, Input, EventEmitter, forwardRef } from '@angular/core';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { _HttpClient } from 'src/app/core/net/http.client';
import { ApiService } from 'src/app/core/net/apiRoute';
import { FormGroup, ControlContainer, FormGroupName, ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, Validator, AbstractControl, ValidationErrors, ValidatorFn, FormControl } from '@angular/forms';

 
@Component({
  selector: 'app-select-organizes',
  templateUrl: './app-select-organizes.component.html',
  styleUrls: ['./app-select-organizes.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppSelectOrganizesComponent),
      multi: true,
    }
  ]
})
export class AppSelectOrganizesComponent implements OnInit, ControlValueAccessor {

  @Input() defaultValue;                                         // 默认选中
  @Output() selectedValue: EventEmitter<string> = new EventEmitter(); // 输出属性
  dataSource: any = [];                                               // 数据源

  constructor(private http: _HttpClient) { }
  propagateChange = (_: any) => { };
  writeValue(value: any): void {
    this.defaultValue = value;
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {

  }
  setDisabledState?(isDisabled: boolean): void {

  }

  ngOnInit(): void {
    this.loadData();
  }

  // 选中的 nz-option 发生变化时
  modelChange(value: string): void {
    this.propagateChange(value);
    this.selectedValue.emit(value);
  }

  // 请求组织列表
  loadData(): void {
    this.http.post(ApiService.GetOrganizes, {})
      .subscribe((res: any) => {
        if (res.Status !== 1) {
          return;
        }
        else {
          this.dataSource = res.Result;
        }
      });
  }
}
